import {
  VectorStyle,
  VectorStyleLayer
} from '../../../../../layer-type-services/vector-tile/twc-vector-tile.layer';
import { TwcProduct } from '../../../../../twc-products';

const WINDS_ALOFT_VECTOR_STYLE_LAYERS: VectorStyleLayer[] = [
  {
    layout: {
      'icon-image': [
        'concat', // Concatenate strings to make each TAF_WIND_BARB
        [
          'case',
          ['<', ['get', 'wspIsobaric'], 5],
          [
            'concat', // Concatenate strings to make each TAF_WIND_BARB
            'Wind_Aloft_',
            'Calm'
          ],
          [
            'concat',
            'Wind_Aloft_',
            [
              'to-string',
              ['*', ['floor', ['/', ['get', 'wspdIsobaric'], 5]], 5]
            ], // Wind speed in multiples of 5
            'kts'
          ]
        ],
        '_Dark'
      ],
      'icon-rotate': ['get', 'wdirIsobaric'],
      'icon-size': 0.55,
      'icon-allow-overlap': false,
      visibility: 'none'
    },
    paint: {},
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'icon-layer-dark',
    custom: {
      basemapShade: 'dark'
    },
    filter: ['all', ['has', 'wspdIsobaric'], ['has', 'wdirIsobaric']],
    type: 'symbol',
    maxzoom: 28
  },
  {
    layout: {
      'icon-image': [
        'case',
        ['<', ['get', 'wspIsobaric'], 5],
        [
          'concat', // Concatenate strings to make each TAF_WIND_BARB
          'Wind_Aloft_',
          'Calm'
        ],
        [
          'concat',
          'Wind_Aloft_',
          ['to-string', ['*', ['floor', ['/', ['get', 'wspdIsobaric'], 5]], 5]], // Wind speed in multiples of 5
          'kts'
        ]
      ],
      'icon-rotate': ['get', 'wdirIsobaric'],
      'icon-size': 0.55,
      'icon-allow-overlap': false,
      visibility: 'none'
    },
    paint: {},
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'icon-layer-day',
    custom: {
      basemapShade: 'light'
    },
    filter: ['all', ['has', 'wspdIsobaric'], ['has', 'wdirIsobaric']],
    type: 'symbol',
    maxzoom: 28
  }
];

export const WINDS_ALOFT_VECTOR_STYLE: VectorStyle = {
  layers: WINDS_ALOFT_VECTOR_STYLE_LAYERS,
  sprite: `assets/weather/sprites/winds-aloft`
};
export const WINDS_ALOFT_PRODUCT_DATA: TwcProduct = {
  id: 'winds-aloft',
  defaultProductId: '1204',
  productName: 'Weather-WindsAloft-TWC',
  label: 'Winds Aloft',
  weatherType: 'WINDS_ALOFT',
  description: 'TWC product (vector, forecast) - Winds Aloft Forecast',
  series: 'Forecast',
  timeSlicePeriodInMinutes: 360,
  lodMax: 5,
  protocol: 'VectorTile',
  forecastTimeSlicePeriod: 360,
  flightLevelProductIds: {
    FL050: '1200',
    FL100: '1201',
    FL140: '1202',
    FL180: '1203',
    FL240: '1204',
    FL300: '1205',
    FL340: '1206',
    FL390: '1207',
    FL450: '1208',
    FL530: '1209'
  },
  zOrder: 90,
  layerSpecs: {
    vectorTile: { vectorStyle: WINDS_ALOFT_VECTOR_STYLE }
  }
};
